import { useTranslate } from "@tolgee/react";

function KeyboardHint({ keys, label }: { keys: string[]; label: string }) {
	return (
		<div className="flex items-center gap-1.5">
			<div className="flex items-center gap-0.5">
				{keys.map((key) => (
					<kbd
						key={key}
						className="inline-flex h-4 min-w-4 items-center justify-center rounded border border-trade-border-subtle bg-trade-surface-raised px-0.5 text-caption1-medium text-trade-text-secondary"
					>
						{key}
					</kbd>
				))}
			</div>
			<span className="text-caption1 text-trade-text-faint">{label}</span>
		</div>
	);
}

export function KeyboardHintsBar() {
	const { t } = useTranslate();
	return (
		<div className="hidden items-center gap-3 border-t border-trade-border-subtle px-3 py-1.5 md:flex">
			<KeyboardHint keys={["/"]} label={t("keyboard.open")} />
			<KeyboardHint
				keys={["\u2191", "\u2193"]}
				label={t("keyboard.navigate")}
			/>
			<KeyboardHint keys={["\u21B5"]} label={t("keyboard.select")} />
			<KeyboardHint keys={["\u2318", "F"]} label={t("keyboard.favorite")} />
			<KeyboardHint keys={["esc"]} label={t("keyboard.close")} />
		</div>
	);
}
